import React from "react";
import LegalShell from "./components/LegalShell";
import { useLang } from "./LangContext";

// All [PLATZHALTER] markers must be replaced before going live.
export default function ImprintPage() {
  const { t } = useLang();
  return (
    <LegalShell>
      <h1>{t.imprintTitle}</h1>

      <h2>Angaben gemäß § 5 TMG</h2>
      <address>
        <span className="legal-placeholder">[Vorname Nachname]</span><br />
        <span className="legal-placeholder">[Straße Hausnummer]</span><br />
        <span className="legal-placeholder">[PLZ Ort]</span><br />
        Deutschland
      </address>

      <h2>Kontakt</h2>
      <p>
        E-Mail: <span className="legal-placeholder">[kontakt@beispiel.de]</span>
      </p>

      <h2>Umsatzsteuer</h2>
      <p>
        <span className="legal-placeholder">
          [Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: DE123456789
          – oder streichen, falls Kleinunternehmer nach § 19 UStG]
        </span>
      </p>

      <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
      <address>
        <span className="legal-placeholder">[Vorname Nachname, Anschrift wie oben]</span>
      </address>

      <h2>Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">
          https://ec.europa.eu/consumers/odr/
        </a>.
        Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </LegalShell>
  );
}
